import { DerivativeWallet } from "./derivative_wallet";
import { TYPE_NAME_ETF } from "@helpers/constants";

export class EtfWallet extends DerivativeWallet {
	public static TypeName: string = TYPE_NAME_ETF;
}
